import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { useTheme } from "../../context/ThemeContext";
import { useAuth } from "../../hooks/useAuth";
import Header from "../common/Header";
import LoadingSpinner from "../common/LoadingSpinner";

const DashboardLayout = ({ children }) => {
  const { isDark } = useTheme();
  const { user, isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div
        className={`min-h-screen ${
          isDark ? "bg-slate-900" : "bg-gray-50"
        } flex items-center justify-center`}
      >
        <div className="text-center">
          <LoadingSpinner size="lg" />
          <p className={`${isDark ? "text-slate-400" : "text-gray-600"} mt-4`}>
            Loading dashboard...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`min-h-screen ${
        isDark ? "bg-slate-900" : "bg-gray-50"
      } transition-colors duration-200`}
    >
      {/* Header */}
      <Header />

      {/* Main Content - Full width without sidebar */}
      <main className="min-h-screen pt-16">
        {" "}
        {/* pt-16 to account for fixed header */}
        <AnimatePresence mode="wait">
          <motion.div
            key={location.pathname}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
            className="h-full"
          >
            {/* Render children if passed directly, otherwise use Outlet for routing */}
            {children || <Outlet />}
          </motion.div>
        </AnimatePresence>
      </main>
    </div>
  );
};

export default DashboardLayout;
